import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Component from "./component";
import { setSsrStatus, getPdiPageData } from "./actions";
import { updateLeadSource } from "../settings/actions";
import { setGaSource } from "../../shared/ga-source/actions";

const mapStateToProps = ({
    preDeliveryInspection: { isSsr, cmsDetails, isInvalidCity },
    gaSource: { source }
}) => ({
    isSsr,
    source,
    cmsDetails,
    isInvalidCity
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getPdiPageDataConnect: getPdiPageData,
    setSSRStatusConnect: setSsrStatus,
    updateLeadSourceConnect: updateLeadSource,
    setGaSourceConnect: setGaSource
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Component);
